import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="10"
    height="2"
    viewBox="0 0 10 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.25 0.5H0.75C0.473858 0.5 0.25 0.723859 0.25 1C0.25 1.27615 0.473858 1.50001 0.75 1.50001H9.25C9.52614 1.50001 9.75 1.27615 9.75 1C9.75 0.723859 9.52614 0.5 9.25 0.5Z"
      fill="#E04949"
    />
  </svg>
);

const MinusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default MinusIcon;
